import React from "react";
import {
  Menu,
  Dropdown,
  Icon,
  Popup,
  Header,
  Button,
  Responsive,
  Flag
} from "semantic-ui-react";
import { Link } from "react-router-dom";
import Activity from "../containers/ActivityContainter";
const getName = user => {
  if (user) {
    return user.firstname && user.surname
      ? user.firstname + " " + user.surname
      : user.email;
  }

  return "";
};

const parseLanguageCode = code => {
  if (code.includes("-")) {
    return code.toLowerCase().split("-")[0];
  } else {
    return code;
  }
};

const NavbarComponent = props => {
  const selectedHotel = props.hotel || {};
  return (
    <Menu
      borderless
      style={{ backgroundColor: "#3b88f9", borderRadius: 0, marginTop: 0 }}>
      <Responsive maxWidth={Responsive.onlyMobile.maxWidth}>
        <Menu.Item>
          <Button inverted icon onClick={props.handleButtonClick}>
            <Icon name="align justify" />
          </Button>
        </Menu.Item>
      </Responsive>

      <Dropdown
        text={selectedHotel.hotelName}
        style={{ color: "white" }}
        className="link item">
        <Dropdown.Menu>
          {props.hotels.map(hotel => (
            <Dropdown.Item
              key={hotel.hotelId}
              onClick={() => props.selectHotel(hotel.hotelId)}>
              {hotel.hotelName}
            </Dropdown.Item>
          ))}
          {props.isAdmin &&
            !props.isSynchronizing && (
              <React.Fragment>
                <Dropdown.Divider />
                <Dropdown.Item as={Link} to={"/hotel/create"}>
                  <Icon name="plus" /> {props.t("navbar:newHotelButton")}
                </Dropdown.Item>
              </React.Fragment>
            )}
        </Dropdown.Menu>
      </Dropdown>
      <Menu.Menu position="right">
        <Responsive minWidth={Responsive.onlyTablet.minWidth}>
          <Menu.Item>
            <Popup
              onMount={props.setIndicate}
              trigger={
                <Icon
                  name="bell"
                  style={{ color: props.indicate ? "red" : "white" }}
                />
              }
              flowing
              hoverable>
              <Header as="h3" content={props.t("navbar:activityHeader")} />
              <Activity />
            </Popup>
          </Menu.Item>
        </Responsive>
        <Dropdown
          text={<Flag name={parseLanguageCode(props.i18n.language)} />}
          style={{ color: "white" }}
          className="link item">
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => props.i18n.changeLanguage("pl")}>
              <Flag name="pl" />
            </Dropdown.Item>
            <Dropdown.Item onClick={() => props.i18n.changeLanguage("gb")}>
              <Flag name="gb" />
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
        <Dropdown
          text={getName(props.user)}
          style={{ color: "white" }}
          className="link item">
          <Dropdown.Menu>
            <Dropdown.Item
              as={Link}
              name="Edit user"
              to={props.user ? "/users/" + props.user.userId : "/"}>
              {props.t("navbar:editUserText")}
            </Dropdown.Item>
            <Dropdown.Item onClick={props.logout}>
              {props.t("navbar:logoutButton")}
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Menu>
  );
};

export default NavbarComponent;



// WEBPACK FOOTER //
// ./src/components/NavbarComponent.js